/* MINIFLACONS · PDP Lab · UI (Galerie, Parallax, Duft-Finder-Match, Bewertungen-Link) */
(() => {
  'use strict';
  const MFL = window.MFL;
  if (!MFL || !MFL.data) return;
  const D = MFL.data, root = MFL.root, DRV = MFL.DRV, vec = MFL.vec, cos = MFL.cos, reduced = MFL.reduced;
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
  /* ------------------------------------------------ Farben & Notenfamilien */
  const FAMC = {
    Frisch: '#7cc8de', Zitrus: '#f1cf3f', 'Grün': '#7fb26f', Aquatisch: '#5aa9dc', Fruchtig: '#f07d63', Blumig: '#ee97b8',
    Pudrig: '#cbb3e3', Holzig: '#9a7048', Erdig: '#7b6646', Synthetisch: '#aab4c2', Orientalisch: '#c46a34', Harzig: '#c58b2c',
    'Würzig': '#d4572b', 'Süß': '#e8a86f', Gourmand: '#b46e37', Cremig: '#e6d2ad', Rauchig: '#77716d', Ledrig: '#6a4630',
    Animalisch: '#8a5a43', Chypre: '#6f7f4b', 'Fougère': '#6c9a78', Aldehydig: '#d9e3ec', Tabak: '#8b5a2e', Aromatisch: '#8f86cf'
  };
  const NOTE_RULES = [
    [/bergamott|zitron|limett|mandarin|orange(?!nblüt)|grapefruit|yuzu|pampelmus|citrus|zitrus|kumquat|bitterorange|petitgrain|cedrat|lemon/, 'Zitrus'],
    [/meer|salz|aquat|wasser|ozon|algen|kalon|seetang|regen/, 'Aquatisch'],
    [/minz|eukalypt|kampfer|menthol|eis|frisch|aldehyd/, 'Frisch'],
    [/lavendel|salbei|rosmarin|thymian|basilikum|estragon|beifuß|geranie|wermut|artemisia|kräuter/, 'Aromatisch'],
    [/tee|matcha|gras|blatt|blätter|galbanum|feigenblatt|tomate|grün|bambus|efeu|farn|mastix|cassis.?knosp|veilchenblatt|petersilie/, 'Grün'],
    [/rose|jasmin|iris|tuberose|hibisk|ylang|magnoli|gardeni|frangipani|osmanthus|mimose|veilchen|pfingstrose|maiglöck|orangenblüt|neroli|heliotrop|lilie|orchid|flieder|freesie|kamille|nelke(?!npfeffer)|immortelle|lotus|blüte|blume|gerani|champaka|narziss|tiare/, 'Blumig'],
    [/apfel|birne|pfirsich|aprikos|beere|johannisbeer|himbeer|erdbeer|kirsch|granatapfel|passionsfrucht|maracuj|ananas|kokos|feige|pflaume|mango|litschi|lychee|melone|quitte|rhabarber|dattel|banane|frucht|cassis|traube|nashi/, 'Fruchtig'],
    [/vanill|tonka|karamell|praline|schokolad|kakao|kaffee|honig|zucker|mandel|milch|marshmallow|cola|keks|zuckerwatte|toffee|nougat|pistazie|haselnuss|sahne|rum|cognac|whisk|likör|gourmand|benzoe(?!harz)|brot|reis|popcorn/, 'Gourmand'],
    [/zimt|kardamom|pfeffer|safran|muskat|nelke|ingwer|koriander|kümmel|piment|anis|sternanis|chili|wacholder|gewürz|curry|kreuzkümmel/, 'Würzig'],
    [/weihrauch|myrrhe|labdanum|zistrose|amber|ambra|elemi|styrax|opoponax|harz|copaiba|tolu|peru|olibanum/, 'Harzig'],
    [/leder|wildleder|suede/, 'Ledrig'],
    [/tabak/, 'Tabak'],
    [/rauch|birkenteer|teer|guajak|cade|asche|feuer/, 'Rauchig'],
    [/moschus|ambrette|iso e|ambrox|cashmeran|kaschmir|puder|pudrig|heliotropin|aldehyd/, 'Pudrig'],
    [/patchouli|moos|eichenmoos|erde|karotte|pilz|trüffel|wurzel/, 'Erdig'],
    [/oud|holz|zeder|sandel|vetiver|akigala|papyrus|zypresse|kiefer|pinie|tanne|birke|treibholz|ebenholz|teak|massoia|guajak/, 'Holzig'],
    [/castoreum|zibet|animal|honig/, 'Animalisch'],
    [/creme|cremig|milchig|butter/, 'Cremig']
  ];
  const fallbackFam = (D.dr && D.dr[0]) || 'Holzig';
  function famOf(note) {
    const cands = [].concat(note.g || [], note.n || []).map(s => String(s).toLowerCase());
    for (const s of cands) for (const [re, fam] of NOTE_RULES) if (re.test(s)) return fam;
    return fallbackFam;
  }
  const colOf = n => FAMC[famOf(n)] || '#b7a796';
  MFL.FAMC = FAMC; MFL.colOf = colOf; MFL.famOf = famOf;

  const MAX_AGE = 120 * 864e5;
  const exTags = dr => {
  const t = [], t3 = dr.slice(0, 3);
  if (t3.includes('Süß') || t3.includes('Gourmand')) t.push('suess');
  if (dr.includes('Rauchig')) t.push('rauch');
  if (dr.includes('Ledrig')) t.push('leder');
  if (t3.includes('Blumig') || t3.includes('Pudrig')) t.push('blumig');
  if (dr.slice(0, 4).includes('Zitrus')) t.push('zitrus');
  if (dr.includes('Erdig')) t.push('erdig');
  if (dr.slice(0, 2).includes('Fruchtig')) t.push('fruchtig');
  return t;
  };


  /* ---------- Galerie ---------- */
  const gal = $('[data-mfl-gallery]');
  const thumbs = $$('.mfl-thumb');
  const slides = $$('.mfl-slide');
  if (gal && slides.length > 1) {
  const go = i => gal.scrollTo({ left: i * gal.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
  thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.index)));
  gal.addEventListener('keydown', e => {
    const i = slides.findIndex(s => s.classList.contains('is-active'));
    if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, i + 1)); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, i - 1)); }
  });
  const io = new IntersectionObserver(ens => ens.forEach(en => {
    if (en.intersectionRatio > .6) {
      const i = +en.target.dataset.index;
      slides.forEach(s => s.classList.toggle('is-active', s === en.target));
      thumbs.forEach(t => t.classList.toggle('is-active', +t.dataset.index === i));
    }
  }), { root: gal, threshold: [.6] });
  slides.forEach(s => io.observe(s));
  }

  /* Parallax des Produktbilds */
  const stage = $('[data-mfl-stage]');
  if (stage && !reduced() && window.matchMedia('(hover: hover)').matches) {
  stage.addEventListener('pointermove', e => {
    const r = stage.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
    stage.style.setProperty('--px', (x * -14).toFixed(1) + 'px');
    stage.style.setProperty('--py', (y * -10).toFixed(1) + 'px');
    stage.style.setProperty('--ps', '1.02');
  });
  stage.addEventListener('pointerleave', () => { stage.style.setProperty('--px', '0px'); stage.style.setProperty('--py', '0px'); stage.style.setProperty('--ps', '1'); });
  }

  /* ---------- Duft-Finder-Match ---------- */
  const matchEl = $('[data-mfl-match]');
  function renderMatch() {
  if (!matchEl) return;
  let pr = null;
  try { const p = JSON.parse(localStorage.getItem('mfq_profile')); if (p && p.s && Date.now() - p.t < MAX_AGE) pr = p; } catch (e) {}
  const dr = (D.dr || []).filter(x => DRV[x]);
  if (!pr || !dr.length) return;
  const ex = pr.ex || [];
  const txt = $('[data-mfl-match-text]', matchEl);
  matchEl.classList.remove('is-ask');
  if (exTags(dr).some(t => ex.includes(t))) {
    matchEl.classList.add('is-low');
    txt.innerHTML = 'Enthält eine Richtung, die du ausgeschlossen hast · <b>Profil ansehen</b>';
    return;
  }
  const m = Math.round(100 * Math.pow(cos(pr.s, vec(dr)), 1.6));
  if (m >= 60) {
    matchEl.classList.add('is-hit');
    $('.mfl-match__orb', matchEl).outerHTML = `<span class="mfl-match__ring" style="--m:${m}"><span>${m}</span></span>`;
    txt.innerHTML = `<b>${m} % Match</b> mit deinem Duftprofil`;
  } else {
    matchEl.classList.add('is-low');
    txt.innerHTML = `${m} % Match · eher außerhalb deines Profils`;
  }
  MFL.match = m;
  }
  renderMatch();
  document.addEventListener('mfq:profile', renderMatch);

  /* Bewertungen-Link → Loox-Bereich */
  const rl = $('[data-mfl-reviews-link]');
  if (rl) rl.addEventListener('click', e => {
  const t = document.querySelector('[id$="__reviews"]') || document.getElementById('looxReviews');
  if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); }
  });

  /* ---------- Warenkorb-Vorteile ---------- */
  const progress = $('[data-mfl-progress]');
  const money = MFL.money;
  let CART = null, CFG = null;
  try { CFG = JSON.parse((document.getElementById('mf-cart-config') || {}).textContent || 'null'); } catch (e) {}
  const rate = () => (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  function tiers() {
    if (!CFG || !CFG.tiers) return [];
    let t = CFG.tiers.filter(Boolean).slice().sort((a, b) => a.amount - b.amount);
    if (!(CFG.shipCountries || []).includes(CFG.country)) t = t.filter(x => x.icon !== 'truck');
    return t;
  }
  async function loadCart() {
    try { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); CART = await r.json(); } catch (e) { CART = null; }
    renderProgress();
  }
  function renderProgress() {
    if (!progress) return;
    const T = tiers();
    const cur = MFL.current;
    if (!T.length || !CART || !cur || !cur.available) { progress.hidden = true; return; }
    const giftC = (CART.items || []).filter(i => i.properties && i.properties._mf_gift).reduce((s, i) => s + i.final_line_price, 0);
    const q = Math.max(0, CART.total_price - giftC), add = cur.price, after = q + add;
    const cents = t => Math.round(t.amount * 100 * rate());
    const posOf = i => (i + 1) / T.length * 100;
    const pct = c => {
      for (let i = 0; i < T.length; i++) {
        const hi = cents(T[i]);
        if (c < hi) { const lo = i ? cents(T[i - 1]) : 0, p0 = i ? posOf(i - 1) : 0; return p0 + (c - lo) / (hi - lo) * (posOf(i) - p0); }
      }
      return 100;
    };
    const unlockedNow = T.filter(t => after >= cents(t) && q < cents(t));
    const next = T.find(t => after < cents(t));
    let msg;
    if (unlockedNow.length) {
      const u = unlockedNow[unlockedNow.length - 1];
      msg = `Mit dieser Auswahl sicherst du dir <b>${u.short || u.label}</b>.`;
      if (next) msg += `<small>Danach noch ${money(cents(next) - after)} ${next.label}.</small>`;
    } else if (next) {
      msg = `Mit dieser Auswahl noch <b>${money(cents(next) - after)}</b> ${next.label}.`;
      const done = T.filter(t => q >= cents(t));
      if (done.length) msg += `<small>${done.map(t => t.short || t.label).join(' · ')} ✓ schon freigeschaltet</small>`;
    } else {
      msg = 'Stark! Mit dieser Auswahl hast du <b>alle Vorteile</b> freigeschaltet.';
    }
    $('[data-mfl-progress-msg]').innerHTML = msg;
    const pNow = pct(q), pAfter = pct(after);
    const nowEl = $('[data-mfl-progress-now]'), addEl = $('[data-mfl-progress-add]');
    nowEl.style.width = pNow + '%';
    addEl.style.left = pNow + '%';
    addEl.style.width = Math.max(0, pAfter - pNow) + '%';
    $('[data-mfl-progress-marks]').innerHTML = T.map((t, i) =>
      `<i class="mfl-mark${after >= cents(t) ? ' is-on' : ''}" style="left:${posOf(i)}%"><span>${t.short || t.label}</span></i>`).join('');
    progress.hidden = false;
  }
  document.addEventListener('mf:cart:open', () => setTimeout(loadCart, 900));
  document.addEventListener('mfl:cart', loadCart);
  document.addEventListener('mfl:variant', renderProgress);
  loadCart();
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') loadCart(); });

  /* ------------------------------------------------ Bento */
  const bento = $('[data-mfl-bento]');
  if (bento) {
    const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
    const countUp = el => {
      const to = parseFloat(el.dataset.mflCount) || 0;
      if (reduced()) return;
      const t0 = performance.now(), dur = 1400;
      const f = t => { const k = clamp((t - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = (to * e).toFixed(1).replace('.', ','); if (k < 1) requestAnimationFrame(f); };
      requestAnimationFrame(f);
    };
    new IntersectionObserver(([e], o) => {
      if (!e.isIntersecting) return;
      bento.classList.add('is-in'); $$('[data-mfl-count]', bento).forEach(countUp); o.disconnect();
    }, { threshold: .2 }).observe(bento);
  }
  $$('[data-mfl-spot], [data-mfl-trio]').forEach(el => el.addEventListener('pointermove', e => {
    const r = el.getBoundingClientRect();
    el.style.setProperty('--mx', (e.clientX - r.left) + 'px'); el.style.setProperty('--my', (e.clientY - r.top) + 'px');
  }));

})();